<template>
  <div>
    <div class="product-add">
      <!--form表单-->
      <el-form ref="form" :model="form" size="small" label-width="150px">
        <div class="common-form">保证金</div>
        <el-form-item label="保证金" prop="money" :rules="[{required: true,message: '请输入保证金'}]">
          <el-input v-model="form.money" placeholder="填写保证金" class="max-w460"></el-input>
        </el-form-item>
        <div class="common-form">保证金说明</div>
        <el-form-item label="保证金说明" prop="illustrate" :rules="[{required: true,message: '请输入保证金'}]">
          <el-input v-model="form.illustrate" type="textarea" placeholder="填写保证金说明" class="max-w460"></el-input>
        </el-form-item>

      </el-form>
    </div>
    <div class="common-button-wrapper">
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </div>
  </div>
</template>
<script>
import Technician from "@/api/technician.js";
export default {
  data() {
    return {
      form: {
        money: "",
        margin_id: "",
        illustrate: ""
      }
    };
  },
  created() {
    this.getDate();
  },
  methods: {
    getDate() {
      Technician.bondEdit({}, true)
        .then(res => {
          this.form = res.data.detail;
        })
        .catch(err => {});
    },
    onSubmit() {
      let self = this;
      let params = {};
      params = self.form;
      self.$refs.form.validate(valid => {
        if (valid) {
          Technician.bondAdd(params, true)
            .then(res => {
              this.$message({
                message: res.msg,
                type: "success"
              });
            })
            .catch(err => {
              this.$message({
                message: err.msg,
                type: "warning"
              });
            });
        }
      });
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/setting/bond/index.vue